export default "__VITE_ASSET__wog2eA3q__"